import { useRef } from 'react'
import LogoS from '../../../assets/images/tpalogo.png'
import './index.scss'

const Logo = () => {
  const solidLogoRef = useRef()


  return (
      <img
        className="solid-logo"
        ref={solidLogoRef}
        src={LogoS}
        alt="JavaScript,  Developer"
      />
  )
}

export default Logo
